import { Card } from "@devhop/ui";
import { CheckCircle2, Clock, ListChecks, XCircle } from "lucide-react";
import type { ChecklistResultStatsResult } from "@/modules/checklist/domain/types/result";

type ChecklistResultStatsCardsProps = {
  stats: ChecklistResultStatsResult;
};

export function ChecklistResultStatsCards({
  stats,
}: ChecklistResultStatsCardsProps) {
  const { total, completed, inProgress, cancelled } = stats.overall;
  const completedPct = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-muted-foreground text-sm">ການບັນທຶກທັງໝົດ</p>
            <p className="mt-1 font-bold text-3xl">{total}</p>
          </div>
          <div className="rounded-full bg-primary/10 p-3">
            <ListChecks className="h-6 w-6 text-primary" />
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-muted-foreground text-sm">ສຳເລັດ</p>
            <p className="mt-1 font-bold text-3xl text-green-600">
              {completed}
            </p>
            <p className="text-muted-foreground text-xs">{completedPct}%</p>
          </div>
          <div className="rounded-full bg-green-500/10 p-3">
            <CheckCircle2 className="h-6 w-6 text-green-600" />
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-muted-foreground text-sm">ກຳລັງດຳເນີນຢູ່</p>
            <p className="mt-1 font-bold text-3xl text-amber-600">
              {inProgress}
            </p>
          </div>
          <div className="rounded-full bg-amber-500/10 p-3">
            <Clock className="h-6 w-6 text-amber-600" />
          </div>
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-muted-foreground text-sm">ຍົກເລີກ</p>
            <p className="mt-1 font-bold text-3xl text-muted-foreground">
              {cancelled}
            </p>
          </div>
          <div className="rounded-full bg-muted p-3">
            <XCircle className="h-6 w-6 text-muted-foreground" />
          </div>
        </div>
      </Card>
    </div>
  );
}
